export default "__VITE_ASSET__CLGV8w4Z__"